import request from '@/utils/request'


// 科技竞赛公告
export function getNoticeList(data) {
    return request({
        url: '/api/teenagers/getNoticeList',
        method: 'GET',
        data
    });
}

// 科技竞赛公告详情
export function getNoticeDetail(id) {
    return request({
        url: `/api/teenagers/getNoticeInfo/${id}`,
        method: 'GET',
    });
}

// 科技活动报道列表
export function getNewsList(data) {
    return request({
        url: '/api/teenagers/getTeenagersStoriesList',
        method: 'GET',
        data
    });
}

// 科技活动报道详情
export function getNewsDetail(id) {
    return request({
        url: `/api/teenagers/getTeenagersStoriesInfo/${id}`,
        method: 'GET',
    });
}


// 科技活动优秀作品列表
export function getWorksList(params) {
    return request({
        url: '/api/teenagers/getTeenagersWorksList',
        method: 'GET',
        params
    });
}


// 科技活动优秀作品详情
export function getWorksDetail(id) {
    return request({
        url: `/api/teenagers/getTeenagersWorksInfo/${id}`,
        method: 'GET',
    });
}

// 科技活动优秀作品类型列表
export function getWorksTypeList() {
    return request({
        url: `/api/teenagers/getTeenagersWorksTypeList`,
        method: 'GET',
    });
}

// 科技活动资料下载列表
export function getDownloadList() {
    return request({
        url: `/api/teenagers/getTeenagersDownloadList`,
        method: 'GET',
    });
}



// WEBPACK FOOTER //
// ./src/api/teenager/index.js